import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/toaster";
import ScrollToTop from "./components/ScrollToTop";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Committee from "./pages/Committee";
import Faculty from "./pages/Faculty";
import Program from "./pages/Program";
import Registration from "./pages/Registration";
import Abstract from "./pages/Abstract";
import Sponsorship from "./pages/Sponsorship";
import Webcasts from "./pages/Webcasts";
import Venue from "./pages/Venue";
import AboutMumbai from "./pages/AboutMumbai";
import Contact from "./pages/Contact";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/committee" element={<Committee />} />
            <Route path="/faculty" element={<Faculty />} />
            <Route path="/program" element={<Program />} />
            <Route path="/abstract" element={<Abstract />} />
            <Route path="/registration" element={<Registration />} />
            <Route path="/sponsorship" element={<Sponsorship />} />
            <Route path="/webcasts" element={<Webcasts />} />
            <Route path="/venue" element={<Venue />} />
            <Route path="/about-mumbai" element={<AboutMumbai />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
